import { Controller } from "@hotwired/stimulus";

/**
 * Muscle Chart Controller
 *
 * Manages bar charts for muscle group data (workout frequency, exercise distribution, etc.)
 */
export default class extends Controller {
  static values = {
    labels: Array,
    data: Array,
  };

  connect() {
    if (
      !this.hasLabelsValue ||
      !this.hasDataValue ||
      this.labelsValue.length === 0
    ) {
      return;
    }

    this.initializeChart();
  }

  initializeChart() {
    const ctx = this.element.getContext("2d");

    // Create a plugin to display data values on bars
    const dataLabelsPlugin = {
      id: "dataLabels",
      afterDatasetsDraw(chart) {
        const { ctx } = chart;

        chart.data.datasets.forEach((dataset, datasetIndex) => {
          const meta = chart.getDatasetMeta(datasetIndex);
          if (!meta.hidden) {
            meta.data.forEach((element, index) => {
              const value = dataset.data[index];
              if (value > 0) {
                // Calculate position inside the bar
                const { x, y, width, height } = element.getProps([
                  "x",
                  "y",
                  "width",
                  "height",
                ]);

                ctx.save();
                // Use white text color for better visibility inside colored bars
                ctx.fillStyle = "#fff";
                ctx.textAlign = "center";
                // Position at the bottom inside the bar
                ctx.textBaseline = "bottom";
                ctx.font = "bold 12px Arial";
                // Position the text 10px from the bottom of the bar
                const textY = y + height - 10;
                ctx.fillText(value, x, textY);
                ctx.restore();
              }
            });
          }
        });
      },
    };

    const config = {
      type: "bar",
      plugins: [dataLabelsPlugin],
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Workouts by Muscle Group",
            data: this.dataValue,
            backgroundColor: [
              "rgba(255, 99, 132, 0.7)",
              "rgba(54, 162, 235, 0.7)",
              "rgba(255, 206, 86, 0.7)",
              "rgba(75, 192, 192, 0.7)",
              "rgba(153, 102, 255, 0.7)",
              "rgba(255, 159, 64, 0.7)",
              "rgba(199, 199, 199, 0.7)",
              "rgba(83, 102, 255, 0.7)",
              "rgba(40, 159, 64, 0.7)",
            ],
            borderColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
              "rgba(75, 192, 192, 1)",
              "rgba(153, 102, 255, 1)",
              "rgba(255, 159, 64, 1)",
              "rgba(199, 199, 199, 1)",
              "rgba(83, 102, 255, 1)",
              "rgba(40, 159, 64, 1)",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false, // Hide the legend
          },
          tooltip: {
            enabled: true,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
        },
      },
    };

    new Chart(ctx, config);
  }
}
